import { Controller } from "@hotwired/stimulus"

// Opens a date-range-modal that lives elsewhere in the DOM (referenced via Stimulus outlet).
// Use on any button or trigger element:
//
//   data-controller="date-range-trigger"
//   data-date-range-trigger-date-range-modal-outlet="#upload-date-modal"
//   data-action="click->date-range-trigger#open"
export default class extends Controller {
  static outlets = ["date-range-modal"]

  open(event) {
    if (event) event.preventDefault()
    if (this.hasDateRangeModalOutlet) {
      this.dateRangeModalOutlet.open()
    }
  }
}
